import './App.scss';
import React from 'react';
import isEmpty from 'lodash.isempty';
import { Spin, ConfigProvider } from 'antd';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Routes } from './components/Routes/Routes';
import { NavigationPanel } from './components/NavigationPanel/NavigationPanel';
import { useApp } from './hooks/useApp';
import './styles/globals.scss';

export function App() {
  const { translationsIsPending, translations, contextHolder, hideNavigation } =
    useApp();

  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}
    >
      <Spin
        spinning={translationsIsPending && isEmpty(translations)}
        wrapperClassName="spin-container h-full"
      >
        {contextHolder}
        {!hideNavigation && <NavigationPanel />}
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                inkBarColor: '#EF8E35',
                itemActiveColor: '#EF8E35',
                itemHoverColor: '#EF8E35',
                itemSelectedColor: '#EF8E35',
              },
            },
          }}
        >
          <Routes />
        </ConfigProvider>
      </Spin>
    </GoogleOAuthProvider>
  );
}
